import * as React from 'react';
import Emptynotes from "./Emptynotes";
import Emptyfiles from "./Emptyfiles";
import Emptydiaries from "./Emptydiaries";
import Emptylogs from "./Emptylogs";
import Emptyparties from "./Emptyparties";
import Emptyactivity from "./Emptyactivity";
import Emptyworkkard from "./EmptyWorkkard";
import Emptyowner from "./EmptyOwner";
import Errorscreen from "./Errorscreen";
import EmptySearchActivity from "./EmptySearchActivity";
import EmptyCombinedView from "./EmptyCombinedView";
import EmptyLetters from "./EmptyLetters";
import EmptyDiary from "./EmptyDiary";
export default class EmptyScreen extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        switch (this.props.name) {
            case "Emptynotes":
                return <Emptynotes {...this.props} />;
            case "Emptyactivity":
                return <Emptyactivity {...this.props} />;
            case "Emptyfiles":
                return <Emptyfiles {...this.props} />;
            case "Emptydiaries":
                return <Emptydiaries {...this.props} />;
            case "Emptylogs":
                return <Emptylogs {...this.props} />;
            case "Emptyparties":
                return <Emptyparties {...this.props} />;
            case "Emptyworkkard":
                return <Emptyworkkard {...this.props} />;
            case "Emptyowner":
                return <Emptyowner {...this.props} />;
            case "Errorscreen":
                return <Errorscreen {...this.props}/>;
            case "EmptySearchActivity":
                return <EmptySearchActivity {...this.props}/>;
            case "EmptyCombinedView":
                return <EmptyCombinedView {...this.props}/>;
            case "EmptyLetters":
                return <EmptyLetters {...this.props}/>;
            case "EmptyDiary":
                return <EmptyDiary {...this.props}/>;
            default:
                return '';
        }
    }
}
